// packages/game-shell/src/sim/fixtures/dsl/GridEncoding.ts

/**
 * Your engine uses "encodedGridSnapshot" like:
 * "A,K,Q,J,T,9|9,T,J,Q,K,A|..."
 *
 * This helper keeps that consistent.
 */
export function encodeGridSnapshot(rows: string[][]): string {
    if (!Array.isArray(rows) || rows.length === 0) {
      throw new Error("encodeGridSnapshot: rows must be a non-empty 2D array.");
    }
  
    const widths = new Set(rows.map((r) => r.length));
    if (widths.size !== 1) {
      throw new Error("encodeGridSnapshot: all rows must have the same length.");
    }
  
    return rows.map((r) => r.join(",")).join("|");
  }
